import React from 'react';
import './check.scss';

export interface ICheck {
  isSelected: boolean;
  className?: string;
}

const Check = ({ isSelected, className }: ICheck) => (
  <div
    data-testid="check"
    className={`ui-check ${isSelected ? 'ui-check-selected' : ''} ${
      className || ''
    }`}
  />
);

Check.defaultProps = {
  className: '',
};
export default Check;
